import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import './ServicesSection.css';

const ServicesSection = ({ animatedItems, servicesRef }) => {
  return (
    <section className="services-section" ref={servicesRef}>
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <h2 className="section-title">Our Solutions</h2>
            <div className="title-underline mx-auto"></div>
            <p className="section-subtitle">
              Comprehensive range of products and services for all your farming needs
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={4} className={`mb-4 ${animatedItems.services ? 'service-card-animated' : ''}`} style={{ animationDelay: '0.1s' }}>
            <Card className="service-card h-100">
              <div className="service-img-container">
                <Card.Img variant="top" src="./images/hen.jpg" alt="Poultry solutions" />
              </div>
              <Card.Body>
                <Card.Title>POULTRY DIVISION</Card.Title>
                <Card.Text>
                  From feed supplements to housing systems, we provide everything needed for optimal poultry health and production.
                </Card.Text>
                <Button variant="outline-primary" className="service-btn">Explore</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className={`mb-4 ${animatedItems.services ? 'service-card-animated' : ''}`} style={{ animationDelay: '0.3s' }}>
            <Card className="service-card h-100">
              <div className="service-img-container">
                <Card.Img variant="top" src="https://images.pexels.com/photos/422218/pexels-photo-422218.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="Large Animal care" />
              </div>
              <Card.Body>
                <Card.Title>ANIMAL DIVISION</Card.Title>
                <Card.Text>
                  Comprehensive solutions for cattle, swine, and small ruminants, focusing on nutrition, health, and productivity.
                </Card.Text>
                <Button variant="outline-primary" className="service-btn">Explore</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className={`mb-4 ${animatedItems.services ? 'service-card-animated' : ''}`} style={{ animationDelay: '0.5s' }}>
            <Card className="service-card h-100">
              <div className="service-img-container">
                <Card.Img variant="top" src="./images/aqua.jpg" alt="Aquaculture systems" />
              </div>
              <Card.Body>
                <Card.Title>AQUA DIVISION</Card.Title>
                <Card.Text>
                  Innovative aquaculture technologies and solutions for sustainable fish and shellfish farming operations.
                </Card.Text>
                <Button variant="outline-primary" className="service-btn">Explore</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ServicesSection;